module.exports = __webpack_public_path__ + "img/category-sport.032a4096.png";